var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	3772: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [1,19,2,24], () => (__webpack_require__.e(1699).then(() => (() => (__webpack_require__(/*! @angular/core */ 1699))))))),
	3498: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [1,19,2,24], () => (__webpack_require__.e(6198).then(() => (() => (__webpack_require__(/*! @angular/common */ 6575))))))),
	3635: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs", [2,7,8,0], () => (__webpack_require__.e(3946).then(() => (() => (__webpack_require__(/*! rxjs */ 9951))))))),
	5893: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs/operators", [2,7,8,0], () => (__webpack_require__.e(8238).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 8238))))))),
	1998: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core/primitives/signals", [1,19,2,24], () => (__webpack_require__.e(7166).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 8186))))))),
	4539: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core/primitives/di", [1,19,2,24], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 4127))))),
	504: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/coercion", [1,19,2,19], () => (__webpack_require__.e(5486).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 5998))))))),
	2771: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/platform", [1,19,2,19], () => (__webpack_require__.e(9878).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 3274))))))),
	4530: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/a11y", [1,19,2,19], () => (__webpack_require__.e(6747).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 3170))))))),
	8715: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/private", [1,19,2,19], () => (__webpack_require__.e(3770).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 3770))))))),
	9076: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/bidi", [1,19,2,19], () => (__webpack_require__.e(498).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 4565))))))),
	1920: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/keycodes", [1,19,2,19], () => (__webpack_require__.e(554).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 554))))))),
	935: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/observers/private", [1,19,2,19], () => (__webpack_require__.e(9291).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 4491))))))),
	2342: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/overlay", [1,19,2,19], () => (__webpack_require__.e(9968).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 2698))))))),
	4789: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/scrolling", [1,19,2,19], () => (__webpack_require__.e(8402).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 275))))))),
	5715: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/forms", [1,19,2,24], () => (__webpack_require__.e(1059).then(() => (() => (__webpack_require__(/*! @angular/forms */ 8849))))))),
	6110: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/portal", [1,19,2,19], () => (__webpack_require__.e(7726).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 3517))))))),
	8342: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/dialog", [1,19,2,19], () => (__webpack_require__.e(4004).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 3108))))))),
	9702: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/observers", [1,19,2,19], () => (__webpack_require__.e(3113).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 6787))))))),
	3366: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common/http", [1,19,2,24], () => (__webpack_require__.e(6857).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6857))))))),
	6910: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/platform-browser", [1,19,2,24], () => (__webpack_require__.e(5937).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 6480))))))),
	9994: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/text-field", [1,19,2,19], () => (__webpack_require__.e(5401).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 5802))))))),
	1369: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/animations/browser", [1,19,2,24], () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 570)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"26": [
		504,
		935,
		2771,
		3498,
		3635,
		3772,
		4530,
		5715,
		5893,
		9076,
		9702,
		9994
	],
	"275": [
		3498,
		3635,
		3772,
		5893
	],
	"498": [
		3498
	],
	"570": [
		3772
	],
	"683": [
		3498,
		3772,
		6910
	],
	"687": [
		3772
	],
	"702": [
		504,
		1920,
		2342,
		2771,
		3498,
		3635,
		3772,
		4530,
		4789,
		5893,
		6110,
		9076
	],
	"895": [
		504,
		2771,
		3498,
		3772,
		4530,
		8715,
		9076
	],
	"1333": [
		504,
		935,
		2771,
		3498,
		3635,
		3772,
		4530,
		5893,
		9076,
		9702
	],
	"1699": [
		1998,
		3635,
		4539,
		5893
	],
	"2226": [
		504,
		935,
		1920,
		2342,
		2771,
		3498,
		3635,
		3772,
		4530,
		4789,
		5715,
		5893,
		6110,
		8715,
		9076
	],
	"2698": [
		3498,
		3635,
		3772,
		5893
	],
	"3108": [
		3498,
		3635,
		3772,
		5893
	],
	"3170": [
		3498,
		3635,
		3772,
		5893
	],
	"3274": [
		3498,
		3772
	],
	"3517": [
		3498,
		3772
	],
	"4004": [
		3498
	],
	"4491": [
		3635,
		3772,
		5893
	],
	"4565": [
		3498,
		3772
	],
	"4860": [
		3635,
		3772,
		5893
	],
	"5309": [
		504,
		1920,
		2771,
		3498,
		3635,
		3772,
		4530,
		5893,
		8715,
		9076
	],
	"5802": [
		3498,
		3635,
		3772,
		5893
	],
	"5937": [
		3366
	],
	"5998": [
		3772
	],
	"6140": [
		1369,
		3498,
		3772
	],
	"6198": [
		3635
	],
	"6480": [
		3366,
		3498,
		3772
	],
	"6515": [
		3366,
		3498,
		3635,
		3772,
		4530,
		5893,
		6910,
		9076
	],
	"6575": [
		3635,
		3772
	],
	"6747": [
		3498,
		3635,
		5893
	],
	"6787": [
		3635,
		3772,
		5893
	],
	"6857": [
		3635,
		5893
	],
	"7401": [
		504,
		1920,
		2342,
		3635,
		3772,
		4530,
		4789,
		5893,
		6110,
		8342,
		9076
	],
	"7726": [
		3498
	],
	"7947": [
		3498,
		3635,
		3772,
		5893,
		6910
	],
	"8402": [
		3498
	],
	"8497": [
		3772,
		4530,
		9076
	],
	"8849": [
		3498,
		3635,
		3772,
		5893
	],
	"9968": [
		3498
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}